<template lang="pug">
transition(name="collapse"
		:duration="duration"
		@before-enter="closeState"
		@enter="openState"
		@after-enter="cleanState"
		@before-leave="openState"
		@leave="closeState"
		@after-leave="cleanState")
	slot(v-if="open")
</template>

<script>
export default {
	props: {
		open: {
			type: Boolean,
			default: false
		},

		duration: {
			type: Number,
			default: null
		}
	},

	methods: {
		openState(el) {
			el.style.height = el.scrollHeight + 'px';
			el.style.marginTop = '';
			el.style.marginBottom = '';
			el.style.paddingTop = '';
			el.style.paddingBottom = '';
		},

		closeState(el) {
			el.style.height = '0';
			el.style.marginTop = '0';
			el.style.marginBottom = '0';
			el.style.paddingTop = '0';
			el.style.paddingBottom = '0';
		},

		cleanState(el) {
			el.style.height = '';
			el.style.marginTop = '';
			el.style.marginBottom = '';
			el.style.paddingTop = '';
			el.style.paddingBottom = '';
		}
	}
};

</script>